<template>
  <el-select
    style="width: 280px"
    filterable
    collapse-tags
    v-model="selectedValue"
    :disabled="disabled"
    :clearable="!required"
    :multiple="multiple"
    :placeholder="required ? '必选' : '非必选'"
  >
    <el-option v-for="item in optionList" :label="item.label" :value="item.id" :key="item.id">
    </el-option>
  </el-select>
</template>

<script>
const RISK_TYPE_TO_URL = {
  battery: 'getBatteryRiskType',
  spock: 'getSpockRiskType',
}
export default {
  name: 'filter-risk-type',

  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    riskType: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      optionList: [],
    }
  },

  computed: {
    selectedValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('update:value', val)
      },
    },
  },

  created() {
    this.getOptionList()
  },

  methods: {
    getOptionList() {
      const url = RISK_TYPE_TO_URL[this.riskType]
      if (!url) return
      if (this.optionList.length > 0) return
      this.fetch
        .get(url)
        .then((res) => {
          const data = res.data || []
          this.optionList = data.map((_) => ({
            id: this.riskType === 'spock' ? _.id : _.label,
            label: _.label,
          }))

          if (this.required && this.optionList[0]) {
            this.selectedValue = this.multiple ? [this.optionList[0].id] : this.optionList[0].id
          }
        })
        .catch(() => {})
    },
  },
}
</script>
